import { $EventBus } from '@/main';
import { listAnnexesByType } from '@/store/modules/agreement/service/agreement.service';

export default {
	name: 'AnnexRegistration',
	props: {
		value: {
			type: [Array],
			required: true,
		},
		agreementTypeId: {
			type: [Number, String],
			required: false,
			default: null,
		},
	},
	data() {
		return {
			headers: [
				{
					text: 'Nombre',
					value: 'name',
					sortable: false,
					align: 'left',
					class: 'primary--text',
				},
				{
					text: 'Tipo',
					value: 'type',
					sortable: false,
					align: 'left',
					class: 'primary--text',
				},
				{
					text: 'Tipo de archivo',
					value: 'fileType',
					sortable: false,
					align: 'left',
					class: 'primary--text',
				},
				{
					text: 'Quitar',
					value: 'remove',
					sortable: false,
					align: 'center',
					class: 'primary--text',
				},
			],
			loading: false,
			isDragging: false,
			annexForm: {
				name: null,
				type: null,
				file: null,
				flag_mandatory: true,
				flag_required_for_provider: false,
				default: false,
			},
		};
	},
	created() {
		this.getAnnexesByType();
	},
	mounted() {},
	computed: {
		annexes: {
			get() {
				return this.value || false;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		canSelectFile() {
			return !!(this.annexForm.name && this.annexForm.type);
		},
		canSubmit() {
			return !!(this.annexForm.name && this.annexForm.type && this.annexForm.file);
		},
	},
	watch: {},
	methods: {
		addAnnex() {
			const type = this.annexForm.type;
			this.annexes.push({
				name: this.annexForm.name,
				type,
				file: this.annexForm.file,
				flag_mandatory: this.annexForm.flag_mandatory,
				flag_required_for_provider: this.annexForm.flag_required_for_provider,
				default: false,
			});
			const label = type === 'CONTRATO' ? 'Contrato' : 'Adenda';
			this.showSnack(`${label} "${this.annexForm.name}" agregado correctamente.`, 'success');
			this.$nextTick(() => {
				this.annexForm.name = null;
				this.annexForm.type = null;
				this.annexForm.file = null;
				if (this.$refs.fileInput) this.$refs.fileInput.value = '';
			});
		},

		removeAnnex(index) {
			this.annexes.splice(index, 1);
		},

		openFilePicker() {
			if (!this.canSelectFile) return;
			this.$refs.fileInput.click();
		},

		onFileChange(event) {
			const file = event.target.files[0];
			if (file) {
				if (this.isValidFile(file)) {
					this.annexForm.file = file;
					if (this.canSubmit) this.addAnnex();
				} else {
					this.showSnack(
						'Solo se permiten archivos PDF, PNG, JPG/JPEG y TIFF',
						'warning'
					);
				}
			}
			event.target.value = '';
		},

		onDragOver() {
			if (!this.canSelectFile) return;
			this.isDragging = true;
		},

		onDragLeave() {
			this.isDragging = false;
		},

		onDrop(event) {
			this.isDragging = false;
			if (!this.canSelectFile) return;
			const file = event.dataTransfer.files[0];
			if (!file) return;
			if (this.isValidFile(file)) {
				this.annexForm.file = file;
				if (this.canSubmit) this.addAnnex();
			} else {
				this.showSnack(
					'Solo se permiten archivos PDF, PNG, JPG/JPEG y TIFF',
					'warning'
				);
			}
		},

		isValidFile(file) {
			const validTypes = [
				'application/pdf',
				'image/png',
				'image/jpeg',
				'image/tiff',
			];
			return validTypes.includes(file.type);
		},

		clearFile() {
			this.annexForm.file = null;
			if (this.$refs.fileInput) this.$refs.fileInput.value = '';
		},

		getFileType(file) {
			if (!file || !file.name) return '—';
			const parts = file.name.split('.');
			return parts.length > 1 ? parts[parts.length - 1].toUpperCase() : '—';
		},

		formattingAnnexes(annexes) {
			if (Array.isArray(annexes)) {
				return annexes.map((annex) => ({
					default: true,
					name: annex?.name,
					type: null,
					file: null,
					flag_required_for_provider: false,
					flag_mandatory: annex?.flag_mandatory,
				}));
			}
			return annexes;
		},

		async getAnnexesByType() {
			if (!this.agreementTypeId) return;
			try {
				const queryParams = { agreement_type_id: this.agreementTypeId };
				const response = await listAnnexesByType(queryParams);
				const annexes = response?.data || [];
				this.annexes = this.formattingAnnexes(annexes);
			} catch (error) {
				this.showSnack(error?.response?.data?.message, 'error');
			}
		},

		showSnack(message, color = 'success') {
			message = Array.isArray(message) ? message.join('<br> ') : message;
			$EventBus.$emit('showSnack', color, message);
		},
	},
	beforeDestroy() {},
	components: {},
};
